module.exports = __webpack_public_path__ + "img/VN.788f31cd.svg";